export default __webpack_public_path__ + "static/media/new-tab-external-link-outline-16px.91ce540a.svg";